
//const API_PREFIX = 'https://apiwifi.hb41.uk/api/front_02_mobile'

import React, { useState } from 'react';
import axios from 'axios';

const fieldList = [
  "token", "name", "type", "json_props", "json_action",
  "json_state", "json_event", "json_sensors", "json_schedule",
  "description"
];
//window.location.href = process.env.REACT_APP_HOST+"/login";
//const API_PREFIX = 'https://apiwifi.hb41.uk/api/front_02_mobile'
const API_PREFIX = process.env.REACT_APP_API + '/api/front_02_mobile'

const prettifyJSON = (data) => {
    try {
      const parsed = JSON.parse(data);
  
      // Only format objects and arrays — not simple strings, numbers, etc.
      if (typeof parsed === 'object' && parsed !== null) {
        return JSON.stringify(parsed, null, 2);
      } else {
        return data; // Plain strings, numbers, etc — return as-is
      }
    } catch (e) {
      return data; // Not valid JSON — return as-is
    }
  };
  
  const getTextAreaRows = (text) => {
    const formattedText = prettifyJSON(text); // Apply the prettify logic here
    const lines = formattedText.split('\n').length;  // Count lines in formatted text
    const estimated = Math.ceil(formattedText.length / 100); // Estimate rows based on character length
    const totalRows = Math.max(lines, estimated); // Use the max of both to determine row count
    return Math.min(totalRows, 50);  // Cap at 50 rows for large data
  };

const DeviceFieldBulkEditor = () => {
  const [selectedField, setSelectedField] = useState("");
  const [deviceData, setDeviceData] = useState([]);
  const [editedData, setEditedData] = useState({});

  const handleFieldSelect = async (e) => {
    const field = e.target.value;
    setSelectedField(field);
    setEditedData({});
    setDeviceData([]);

    if (!field) return;

    try {
      const response = await axios.get(
        `${API_PREFIX}/sp_get_device_data_by_fields?field=${field}`
      );
      setDeviceData(response.data.rows || []);
    } catch (err) {
      console.error("Fetch error:", err);
      alert("Failed to fetch device data.");
    }
  };

  const handleTextChange = (id, value) => {
    //setEditedData(prev => ({ ...prev, [id]: value })); //.replace(/'/g, '"') // Convert single quotes to double quotes
    setEditedData(prev => ({ ...prev, [id]: value}));
  };

  const handleUpdate = async (id) => {
    console.log('id, selectedField, text: ', id, selectedField, editedData) 
    //let's test JSON text if it was field name like "json_xxx"

    /* edited data is like
    {
      "1": "{  //Hello3\n  remoteControl: \"temperature and humidity\" }",
      "2": "{  //Hello4\n  remoteControl: \"temperature and humidity\" }"
    }
    */

    //Correct ' to "  in object editedData
    setEditedData(convertSingleQuotesToDouble(editedData))
    //it needs because setEditedData() very slow
    const editedDataPlus = convertSingleQuotesToDouble(editedData)
    //change 

    for (const [key, v] of Object.entries(editedDataPlus)) {
      if (key == id) { //key is string
        if (selectedField.includes("json")){
          console.log(typeof(key))
          if (!parseStrJsonToJson(v)) return null
        }
      }
    }
      //if (!parseStrJsonToJson(editedData)) return null

    const text = editedDataPlus[id];
    try {
      await axios.post(`${API_PREFIX}/sp_update_device_data_by_devid_fields_and_data`, {
        id,
        field: selectedField,
        text
      });

      setEditedData(prev => {
        const newState = { ...prev };
        delete newState[id];
        return newState;
      });

      const res = await axios.get(`${API_PREFIX}/sp_get_device_data_by_fields_and_id?field=${selectedField}&id=${id}`);
      const updatedRow = res.data?.rows?.[0];

      if (updatedRow) {
        setDeviceData(prev =>
          prev.map(row => row.id === id ? updatedRow : row)
        );
      }

    } catch (err) {
      console.error("Update failed:", err);
      alert("Failed to update data.");
    }
  };

  return (
    <div className="container my-4">
      <h4 className="mb-4 text-secondary">Device Field Bulk Editor</h4>

      <div className="mb-4">
        <label htmlFor="fieldSelect" className="form-label">Select Field:</label>
        <select
          id="fieldSelect"
          className="form-select"
          value={selectedField}
          onChange={handleFieldSelect}
        >
          <option value="">-- Select a field --</option>
          {fieldList.map(field => (
            <option key={field} value={field}>{field}</option>
          ))}
        </select>
      </div>

      {selectedField && deviceData.length > 0 && (
        <div className="table-responsive">
          <table className="table table-bordered align-middle">
            <thead className="table-light">
              <tr>
                <th style={{ width: "5%" }}>ID</th>
                <th style={{ width: "75%" }}>{selectedField}</th>
                <th style={{ width: "20%" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {deviceData.map(device => {
                const original = device[selectedField] ?? "";
                const edited = editedData[device.id] ?? original;
                const isChanged = edited !== original;

                return (
                  <tr key={device.id}>
                    <td>{device.id}</td>
                    <td>
                    <textarea
                    className="form-control font-monospace" // Add monospace font for readability
                    value={edited}
                    onChange={(e) => handleTextChange(device.id, e.target.value)}
                    rows={getTextAreaRows(edited)} // Dynamically set rows based on content size
                    style={{ resize: "vertical", maxHeight: "600px" }} // Allow vertical resizing with max height
                    />
                    <p className='text-info'>{device.details}</p>
                    </td>
                    <td>
                      <button
                        className={`btn w-100 ${isChanged ? 'btn-primary' : 'btn-secondary'}`}
                        disabled={!isChanged}
                        onClick={() => handleUpdate(device.id)}
                      >
                        {isChanged ? "Update" : "Saved"}
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default DeviceFieldBulkEditor;


const parseStrJsonToJson1 = (strJson) => {
  if (typeof strJson !== 'string') {
    console.error('Expected a string, got:', typeof strJson);
    return false;
  }

  const cleanedString = strJson
    .replace(/\/\/.*$/gm, '') // Remove line comments
    .replace(/[\r\n]+/g, '')  // Remove newlines
    .replace(/([{,]\s*)([a-zA-Z0-9_]+)(\s*:)/g, '$1"$2"$3') // Quote unquoted keys only
    .replace(/'/g, '"') // Replace single with double quotes
    .replace(/,\s*([\]}])/g, '$1') // Remove trailing commas
    .trim();


/*     .replace(/\/\/.*$/gm, '')                                      // Remove comments
    .replace(/[\r\n]+/g, '')                                       // Remove newlines
    .replace(/;\s*$/, '')                                          // Remove trailing semicolons
    .replace(/([{,]\s*)([a-zA-Z_][a-zA-Z0-9_]*)\s*:/g, '$1"$2":') // Quote object keys
    .replace(/'/g, '"')                                            // Convert single to double quotes
    .replace(/,\s*([\}\]])/g, '$1')                                // Remove trailing commas
    .replace(/(\s*:\s*)(null)/g, '$1null')                         // Keep null
    .replace(/(\s*:\s*)(true|false)/g, '$1$2');                    // Keep booleans 
    .trim();
*/

/*     .replace(/\/\/.*$/gm, '') // Remove single-line comments (//...)
    .replace(/[\r\n]+/g, '') // Remove new lines
    .replace(/;\s*$/, '') // Remove trailing semicolon
    .replace(/(\w+):/g, '"$1":') // Wrap keys in double quotes
    .replace(/'/g, '"') // Replace single quotes with double quotes
    .replace(/,\s*([\}\]])/g, '$1') // Remove trailing commas
    .replace(/(\s*:\s*)(null)/g, '$1null')
    .replace(/(\s*:\s*)(true|false)/g, '$1$2');
    .trim(); */
    //console.log(cleanedString)

  try {
    const parsed = JSON.parse(cleanedString);
    return true
  } catch (err) {
    alert('Invalid JSON format');
    return false
  }
};


const parseStrJsonToJson = (strJson) => {
  if (typeof strJson !== 'string') {
    console.error('Expected a string, got:', typeof strJson);
    return false;
  }
  //console.log('cleanJsonString: ', cleanJsonString(strJson))
  if(!cleanAndParseJson(strJson)) {
    alert('Invalid JSON format');
    return false
  }

  return true

};

const cleanAndParseJson = (str) => {
  if (typeof str !== 'string') {
    console.error('Expected a string, got:', typeof str);
    return null;
  }

  let inString = false;
  let escapeNext = false;
  let result = '';

  // Step 1: Remove comments (but preserve URLs like http://, https://)
  for (let i = 0; i < str.length; i++) {
    const char = str[i];

    // Handle escaped quotes in strings (like \" or \')
    if (inString && char === '\\') {
      escapeNext = true;
      result += char;
      continue;
    }

    // Toggle string state (skip if escaped)
    if ((char === '"' || char === "'") && !escapeNext) {
      inString = !inString;
    }

    escapeNext = false;

    // Skip comment processing inside strings
    if (!inString) {
      // Check for URLs (http:// or https://) and skip them
      const nextChars = str.substring(i, i + 8).toLowerCase();
      if (nextChars.startsWith('http://') || nextChars.startsWith('https:/')) {
        result += char;
        continue;
      }

      // Remove single-line comments (//)
      if (char === '/' && str[i + 1] === '/') {
        while (i < str.length && str[i] !== '\n') i++;
        continue;
      }

      // Remove multi-line comments (/* */)
      if (char === '/' && str[i + 1] === '*') {
        i += 2;
        while (i < str.length && !(str[i] === '*' && str[i + 1] === '/')) i++;
        i += 1;
        continue;
      }
    }

    result += char;
  }

  // Step 2: Convert JS-style object to valid JSON
  const jsonLike = result
    .replace(/([{,]\s*)([a-zA-Z_][a-zA-Z0-9_]*)\s*:/g, '$1"$2":') // Quote keys
    .replace(/'/g, '"') // Replace single quotes
    .replace(/,\s*([}\]])/g, '$1') // Remove trailing commas
    .trim();

  // Step 3: Parse safely
  try {
    return JSON.parse(jsonLike);
  } catch (err) {
    console.error('Failed to parse JSON:', err.message);
    return null;
  }
};

const cleanJsonString = (str) => {
  let inString = false;
  let escapeNext = false;
  let result = '';

  for (let i = 0; i < str.length; i++) {
    const char = str[i];

    // Handle escape sequences (like \', \")
    if (inString && char === '\\') {
      escapeNext = true;
      result += char;
      continue;
    }

    // Toggle string state (skip escaped quotes)
    if ((char === '"' || char === "'") && !escapeNext) {
      inString = !inString;
    }

    escapeNext = false;

    // Skip comment processing inside strings
    if (!inString) {
      // Check for URLs (http:// or https://) and skip them
      const nextChars = str.substring(i, i + 8).toLowerCase();
      if (nextChars.startsWith('http://') || nextChars.startsWith('https:/')) {
        result += char;
        continue;
      }

      // Remove single-line comments (//)
      if (char === '/' && str[i + 1] === '/') {
        while (i < str.length && str[i] !== '\n') i++;
        continue;
      }

      // Remove multi-line comments (/* */)
      if (char === '/' && str[i + 1] === '*') {
        i += 2;
        while (i < str.length && !(str[i] === '*' && str[i + 1] === '/')) i++;
        i += 1;
        continue;
      }
    }

    result += char;
  }

  // Convert JS object to valid JSON
  const jsonLike = result
    .replace(/([{,]\s*)([a-zA-Z_][a-zA-Z0-9_]*)\s*:/g, '$1"$2":') // Quote keys
    .replace(/'/g, '"') // Convert single quotes to double quotes
    .replace(/,\s*([}\]])/g, '$1') // Remove trailing commas
    .trim();

  return jsonLike;
};

function convertSingleQuotesToDouble(jsonObj) {
  const result = {};

  for (const key in jsonObj) {
    if (typeof jsonObj[key] === 'string') {
      // Replace single quotes only inside the value string
      result[key] = jsonObj[key].replace(/'([^']*)'/g, '"$1"');
    } else {
      result[key] = jsonObj[key];
    }
  }

  return result;
}